import { FC } from 'react'

import OnboardingFormSection, {
  OnboardingFormSectionProps,
} from '../../components/OnboardingFormSection'
import CoverSection, { CoverSectionProps } from '../../components/CoverSection'
import { BreadcrumbProps } from '../../components/Breadcrumb'
import TagCommander, { TcProps } from '../../components/TagCommander'
import { SeoProps } from '../../components/Seo'

import * as SC from './styled'

export type OnboardingTemplateProps = {
  coverSectionProps?: CoverSectionProps
  onboardingSectionProps?: OnboardingFormSectionProps
  mobileBreadcrumbProps?: BreadcrumbProps
  tcProps?: TcProps
  seoProps?: SeoProps
}

const OnboardingTemplate: FC<OnboardingTemplateProps> = ({
  coverSectionProps,
  onboardingSectionProps,
  mobileBreadcrumbProps,
  tcProps,
}) => {
  return (
    <SC.TemplateWrapper>
      {tcProps && <TagCommander {...tcProps} />}
      <SC.Main>
        {coverSectionProps && <CoverSection {...coverSectionProps} />}
        {onboardingSectionProps && (
          <OnboardingFormSection {...onboardingSectionProps} />
        )}
      </SC.Main>
      {mobileBreadcrumbProps && (
        <SC.MobileBreadcrumb {...mobileBreadcrumbProps} />
      )}
    </SC.TemplateWrapper>
  )
}

export default OnboardingTemplate
